/* eslint-disable prettier/prettier */
import * as Yup from 'yup';
import CrudFormLayout from '../../../Layout/CrudFormLayout';
import { formDataConverter, formDataConverterNew } from '../../../../utils/necessaryFunctions';
import ProductForm from './ProductForm';

const ProductFormContainer = ({ apiHandler, editData }) => {
    console.log("editData", editData)
    const initialValues = {
        name: editData?.name || '',
        price: editData?.price || '',
        productCategoryId: editData?.productCategoryId || '',
        description: editData?.description || '',
        featured: editData?.featured === 0 ? 0 : 1 || 0,
        popular: editData?.popular === 0 ? 0 : 1 || 0,
        status: editData?.status === 0 ? 0 : 1 || 1,
        features: editData?.features?.map((item) => ({
            value: item.value,
        })) || [{ value: '' }],
        features_optional: editData?.features_optional?.map((item) => ({
            value: item.value,
        })) || [{ value: '' }],
        product_model: editData?.product_model?.map((item) => ({
            model_name: item?.model_name || '',
            feeds_per_inch: item?.feeds_per_inch || '',
            sinker_top: item?.sinker_top || '',
            gauge: item?.gauge || '',
            diameter_range: item?.diameter_range || '',
            speed_factor: item?.speed_factor || '',
        })) || [],
        // model: editData?.model?.map((item) => ({
        //     model_name: item?.model_name,
        //     feeds_per_inch: item?.feeds_per_inch,
        //     sinker_top: item?.sinker_top,
        //     gauge: item?.gauge,
        //     diameter_range: item?.diameter_range,
        //     speed_factor: item?.speed_factor
        // }))|| [
        //         { model_name: '' },
        //         { feeds_per_inch: '' },
        //         { sinker_top: '' },
        //         { gauge: '' },
        //         { diameter_range: '' },
        //         { speed_factor: '' }
        //     ]
        // ,
    };
    //! Active validationSchema testing
    // const validationSchema = Yup.object().shape({
    //     name: Yup.string().required('Name is required'),

    //     price: Yup.number()
    //         .typeError('Price must be a number')
    //         .required('Price is required')
    //         .positive('Price must be a positive number'),
    //     tourType: Yup.string().required('Tour Type ID is required'),

    //     duration: Yup.number()
    //         .typeError('Duration must be a number')
    //         .required('Duration is required'),

    //     package_discount: Yup.number()
    //         .typeError('Discount must be a number')
    //         .min(0, 'Discount cannot be negative')
    //         .max(100, 'Discount cannot be more than 100')
    //         .nullable(),

    //     status: Yup.number().oneOf([0, 1], 'Status must be either 0 or 1'),

    //     included: Yup.array().of(
    //         Yup.object().shape({
    //             value: Yup.string().required('Included item value is required'),
    //         })
    //     ),

    //     excluded: Yup.array().of(
    //         Yup.object().shape({
    //             value: Yup.string().required('Excluded item value is required'),
    //         })
    //     ),

    //     highlights_bulletpoints: Yup.array().of(
    //         Yup.object().shape({
    //             value: Yup.string().required('Highlight bullet point is required'),
    //         })
    //     ),

    //     itinerary: Yup.array().of(
    //         Yup.object().shape({
    //             value: Yup.string().required('Itinerary item is required'),
    //         })
    //     ),

    //     features: Yup.array().of(
    //         Yup.object().shape({
    //             name: Yup.string().required('Feature name is required'),
    //             value: Yup.string().required('Feature value is required'),
    //         })
    //     ),
    // });

    const validationSchema = Yup.object().shape({
        //     // name: Yup.string().required('Name is required'),
        //     // price: Yup.number()
        //     //     .typeError('Price must be a number')
        //     //     .required('Price is required')
        //     //     .positive('Price must be a positive number'),
        //     // tourType: Yup.string().required('Tour Type ID is required'),
        //     // duration: Yup.string().required('Duration ID is required'),
        //     // package_discount: Yup.number()
        //     //     .typeError('Discount must be a number')
        //     //     .min(0, 'Discount cannot be negative')
        //     //     .max(100, 'Discount cannot be more than 100')
        //     //     .nullable(),
        //     // status: Yup.number().oneOf([0, 1], 'Status must be either 0 or 1'),
        //     // features: Yup.array().of(
        //     //     Yup.object()
        //     //         .shape({
        //     //             name: Yup.string().required('Feature name is required'),
        //     //             value: Yup.string(),
        //     //         })
        //     //         .optional()
        //     // ),
    });

    const formHandler = (values) => {
        console.log('Before apiHandler Form Values: ', values);
        // return null;
        const formData = formDataConverterNew(values);
        console.log('After formData Convert formData: ', formData);
        if (apiHandler) {
            console.log("formData inside formContainer", formData)
            return apiHandler(formData);
            // return apiHandler(values);
        }
        return null;
    };

    return (
        <div>
            <CrudFormLayout
                initialValues={initialValues}
                buttonCenter
                apiHandler={formHandler}
                validationSchema={validationSchema}
            >
                <ProductForm />
            </CrudFormLayout>
        </div>
    );
};

export default ProductFormContainer;
